export default __webpack_public_path__ + "static/media/trr-drink-coffee-cappuccino.becf5e36.png";